import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PermissionService } from '../permission.service';
import { MIHttpClientService } from 'src/app/shared/mi-http-client.service';
import { IdName } from 'src/app/shared/common-interfaces';
import { IHelpdeskTicket } from './helpdesk-ticket.component';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { LabelingService } from 'src/app/shared/labeling.service';


export interface IKeyNamePermisson {
  key: string;
  name: Observable<string>;
  permission: string;
}

@Injectable({
  providedIn: 'root',
})
export class HelpdeskService {

  modules: IKeyNamePermisson[] = [
    {key: 'Reports', name: this.translateService.stream(marker('Reports')),
    permission: `'DASHBOARD_VIEW', 'CONTRIBUTION_REPORT_VIEW', 'FORM_SUMMARY_REPORT', 'REPORT_BUILDER','QRVEY_REPORTS'`},
    {key: 'Users', name: this.translateService.stream(marker('Users')),
    permission: `'USER_VIEW', 'GROUP_VIEW', 'TASK_VIEW'`},
    {key: 'Stores', name: this.labelingService.getStoresLabel(),
    permission: `'STORE_VIEW', 'CONTACT_VIEW', 'ACCOUNT_VIEW'`},
    {key: 'Sales Goals', name: this.translateService.stream(marker('Sales Goals')),
    permission: `'SALES_GOALS_IMPORT'`},
    {key: 'Jobs Batches', name: this.translateService.stream(marker('Jobs Batches')),
    permission: `'ACTIVITY'`},
    {key: 'Calendar', name: this.translateService.stream(marker('Calendar')),
    permission: `'OUT_OF_OFFICE_EVENT_VIEW'`},
    {key: 'Forms', name: this.translateService.stream(marker('Forms')),
    permission: `'DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY', 'ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT', 'ADHOC_VISIT_VIEW', 'STORE_VISIT_VIEW'`},
    {key: 'Viba', name: this.translateService.stream(marker('Viba')),
    permission: `'VIBA_USER', 'VIBA_ADMIN'`},
  ];

  constructor(
    private miClient: MIHttpClientService,
    private translateService: TranslateService,
    private permissionsServie: PermissionService,
    private labelingService: LabelingService,
  ) {
  }

  getModules(): Observable<IdName[]> {

      const response = [];
      let text = '';
      this.modules.forEach(item => {
        if (this.hasPermission(item)) {
          item.name.subscribe(data => text = data);
          response.push({
            id: item.key,
            name: item.name,
          });
        }
      });
      return of(response);
  }

  sendTicket(item: IHelpdeskTicket): Observable<any> {
    return this.miClient.post('helpdesk', item);
  }

  private hasPermission(item: IKeyNamePermisson) {
    return this.permissionsServie.hasAtLeastOnePermission(item.permission);
  }
}
